/* Copyright (c) 2021-2023 Nordcloud Oy or its affiliates. All Rights Reserved. */

import { useExpandableTagQuery } from "~/generated/graphql";
import { mapData } from "./mapping";

type Props = {
  name: string;
  value: string[];
};

export function useGetDataByIds({ name: fieldName, value }: Props) {
  const fieldPreset = {
    isApp: fieldName === "application",
    isEnv: fieldName === "environment",
    isCategory: fieldName === "category",
    isPolicy: fieldName === "wastePolicy",
    isService: fieldName === "service",
    isExternal: ["externalIntegration", "enrichmentIntegrationId"].includes(
      fieldName
    ),
  };

  const { loading, error, data } = useExpandableTagQuery({
    fetchPolicy: "cache-and-network",
    variables: {
      ids: value,
      ...fieldPreset,
    },
  });

  return {
    data: mapData(data, fieldPreset, value) ?? [],
    error,
    loading,
  };
}
